module.exports = __webpack_public_path__ + "img/OGBull.05509.d9cbb37e.webp";